import { ICollaborator } from '../types';
export class CollaboratorMatcher {
  private nameMap: Map<string, ICollaborator> = new Map();
  private nameLowerCaseMap: Map<string, ICollaborator> = new Map();
  private identifierLowerCaseMap: Map<string, ICollaborator> = new Map();

  constructor(collaborators?: ICollaborator[]) {
    if (!collaborators || !collaborators.length) return;

    const repeatedNameSet: Set<string> = new Set();
    const repeatedNameLowerCaseSet: Set<string> = new Set();
    const repeatedIdentifierLowerCaseSet: Set<string> = new Set();

    collaborators.forEach((col) => {
      this.setMap(col.nickName, col, this.nameMap, repeatedNameSet);

      const nameLowerCase = col.nickName.toLocaleLowerCase();
      this.setMap(
        nameLowerCase,
        col,
        this.nameLowerCaseMap,
        repeatedNameLowerCaseSet
      );

      // Maybe the business can guarantee that the emails(phone numbers) are not the same, but the CollaboratorMatcher cant
      if (col.email) {
        const emailLowerCase = col.email.toLocaleLowerCase();
        this.setMap(
          emailLowerCase,
          col,
          this.identifierLowerCaseMap,
          repeatedIdentifierLowerCaseSet
        );
      }
      if (col.phoneNumber) {
        this.setMap(
          col.phoneNumber,
          col,
          this.identifierLowerCaseMap,
          repeatedIdentifierLowerCaseSet
        );
      }
    });
  }

  /**
   * If there is a repeated key, it should not match any data
   */
  private setMap(
    key: string,
    value: ICollaborator,
    map: Map<string, ICollaborator>,
    repeatedSet: Set<string>
  ) {
    if (repeatedSet.has(key)) return;

    if (map.has(key)) {
      repeatedSet.add(key);
      map.delete(key);
    } else {
      map.set(key, value);
    }
  }

  /**
   * Match the nickname first, then match the email or phone number
   * @see {@link https://www.notion.so/youthful-polka-128/a7b755b000ca4f069b33440ee23f726b}
   */
  public match(stringValue: string): ICollaborator | null {
    if (!stringValue) return null;

    const nameMatchResult = this.nameMap.get(stringValue);
    if (nameMatchResult) return nameMatchResult;

    const strLowerCaseValue = stringValue.toLocaleLowerCase();

    const nameLoMatchResult = this.nameLowerCaseMap.get(strLowerCaseValue);
    if (nameLoMatchResult) return nameLoMatchResult;

    const identifierLoMatchResult =
      this.identifierLowerCaseMap.get(strLowerCaseValue);
    if (identifierLoMatchResult) return identifierLoMatchResult;

    return null;
  }
}
